import log from "../logger/logger";

export interface IBleEventArgs<T> {
    data: T
}

export default class EventEmitter<T> {
    private events: {[key: string]: Array<(arg0: IBleEventArgs<any>) => void>};

    constructor() {
        this.events = {};
    }

    subscribe(eventName: string, callback: (arg0: IBleEventArgs<T>) => void) {
        log.info(`Subscribe on event: ${eventName}`)
        !this.events[eventName] && (this.events[eventName] = []);
        this.events[eventName].push(callback);
    }
    unsubscribe(eventName: string, callback: (arg0: IBleEventArgs<T>) => void) {
        log.info(`Unsubscribe on event: ${eventName}`)
        this.events[eventName] = this.events[eventName]?.filter(eventCallback => callback !== eventCallback);
    }

    emit(eventName: string, args: IBleEventArgs<T>) {
        const event = this.events[eventName];
        event && event?.forEach(callback => callback.call(null, args));
    }

    isEnySubscriptions():boolean {
        return Object.values(this.events).some(item => item.length);
    }

    destroy() {
        Object.keys(this.events).forEach((key) => {
            this.events[key] = [];
            delete this.events[key];
        });
    }
}